class CartDrawer extends HTMLElement {
  constructor() {
    super()

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close())
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this))
    this.setHeaderCartIconAccessibility()
    this.removeCorso()
    this.paramHandle()
  }

  get cart() {
    return JSON.parse(this.querySelector('[data-cart-json]').innerHTML)
  }

  removeCorso() {
    const corsoProductId = this.dataset.corsoProductId
      ? parseInt(this.dataset.corsoProductId)
      : false

    let updates = {}
    this.cart.items.forEach((item) => {
      if (item.product_id === corsoProductId) {
        updates[item.variant_id] = 0
      }
    })
    if (Object.keys(updates).length !== 0) {
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates }),
      })
        .then((response) => {
          return response.json()
        })
        .then((response) => {
          document.dispatchEvent(
            new CustomEvent('cartaddsuccess', {
              detail: {
                openCart: false,
              },
              bubbles: true,
            }),
          )
        })
        .catch((error) => {
          console.error('Error:', error)
        })
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble')
    if (!cartLink) return

    cartLink.setAttribute('role', 'button')
    cartLink.setAttribute('aria-haspopup', 'dialog')
    cartLink.addEventListener('click', (event) => {
      event.preventDefault()
      this.open(cartLink)
    })
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault()
        this.open(cartLink)
      }
    })
  }

  open(triggeredBy) {
    // document.dispatchEvent(new Event('CartDrawer:open'))

    this.sectionRenderContent()

    if (this.classList.contains('active')) {
      return
    }

    if (triggeredBy) this.setActiveElement(triggeredBy)
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary')
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role'))
      this.setSummaryAccessibility(cartDrawerNote)
    this.classList.add('animate', 'active')
    setTimeout(() => {
      this.classList.remove('drawer-enable-animation')
    }, 3000)

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer')
        const focusElement =
          this.querySelector('.drawer__inner') || this.querySelector('.drawer__close')

        trapFocus(containerToTrapFocusOn, focusElement)

        const cartAttributes = this.querySelector('cart-attributes')
        if (cartAttributes && typeof cartAttributes.validateAndSetValues === 'function') {
          cartAttributes.validateAndSetValues()
        }
      },
      { once: true },
    )

    document.body.classList.add('overflow-hidden')

    // Update GA attributes with /cart/update.js API
    const cartAttributes = this.querySelector('cart-attributes')
    if (
      document.body.dataset.checkout &&
      document.body.dataset.checkout !==
        cartAttributes.querySelector('[name="attributes[checkout_test]"]').value
    ) {
      cartAttributes.querySelector('[name="attributes[checkout_test]"]').value =
        document.body.dataset.checkout
      cartAttributes.dataset.requiresUpdate = 'true'
    }
    if (cartAttributes.dataset.requiresUpdate === 'true') {
      cartAttributes?.updateGaAttributes()
    }
  }

  sectionRenderContent() {
    if (this.querySelector('.cart-drawer-addon--skeleton') === null) {
      return
    }
    const sections = ['cart-drawer-addon-infinite-content']
    fetch(`${window.Shopify.routes.root}?sections=${sections.toString()}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText
        const responseSections = JSON.parse(html)
        sections.forEach((sectionId, index) => {
          const responseSection = responseSections[sectionId]
          this.querySelector('cart-drawer-addon-infinite-content').innerHTML = responseSection
          // open tab automatically if non is opened
          if (
            this.querySelector('cart-drawer-addon-tabs-toggle.active') === null &&
            this.querySelector('cart-drawer-addon-tabs-toggle') !== null
          ) {
            this.querySelector('cart-drawer-addon-tabs-toggle').dispatchEvent(new Event('click'))
          }
        })
      })
      .catch((e) => {
        console.error(e)
      })
  }

  close() {
    this.classList.remove('active')
    setTimeout(() => {
      this.classList.remove('animate')
    }, 200)
    removeTrapFocus(this.activeElement)
    document.body.classList.remove('overflow-hidden')
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button')
    cartDrawerNote.setAttribute('aria-expanded', 'false')

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id)
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open'),
      )
    })

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape)
  }

  renderContents(parsedState, openCart = true) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty')
    this.productId = parsedState.id
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id)

      if (!sectionElement) return

      if (parsedState.sections !== null) {
        sectionElement.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector,
        )
      } else {
        console.log('parsedState.sections is returned null')
      }
    })

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this))
      openCart && this.open()
    })

    this.classList.add('drawer-enable-animation')
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ]
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)
  }

  setActiveElement(element) {
    this.activeElement = element
  }

  paramHandle() {
    if (location.search.includes('cart-open=1')) {
      this.open()
    }
  }
}

customElements.define('cart-drawer', CartDrawer)

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ]
  }
}

customElements.define('cart-drawer-items', CartDrawerItems)

class CartAttributes extends HTMLElement {
  constructor() {
    super()
    this.initialized = false
    this.init()
  }

  init() {
    if (this.initialized) return
    this.initialized = true

    this.querySelectorAll('input[data-cookie-key]').forEach((input) => {
      this.setupInput(input)
    })

    this.addEventListener('submit', this.validateAndSetValues.bind(this), true)
    document.addEventListener('cartaddsuccess', this.validateAndSetValues.bind(this))
    // window.addEventListener('load', this.updateGaAttributes.bind(this))
  }

  updateGaAttributes() {
    this.validateAndSetValues()
    let update = false
    let formData = new FormData()

    document.querySelectorAll('cart-attributes input').forEach((input) => {
      if (input.value !== '') {
        update = true
        const attributeKey = input.getAttribute('name').replace('attributes[', '').replace(']', '')

        formData.append(`attributes[${attributeKey}]`, input.value)
      }
    })
    if (update) {
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData,
      })
        .then((response) => response.json())
        .then((response) => {
          console.log('%cCart attributes updated:', 'font-size: 14px; color: #7cc87c;', response)
          this.removeAttribute('data-requires-update')
        })
    }
  }

  setupInput(input) {
    const cookieKey = input.dataset.cookieKey

    switch (cookieKey) {
      case '_ga':
        this.setupGaClientId(input)
        break
      case '_ga_5BM1C2LY27':
        this.setupGaSessionId(input)
        break
    }
  }

  setupGaClientId(input) {
    const gaCookie = getCookie('_ga')

    if (gaCookie) {
      const parts = gaCookie.split('.')
      if (parts.length >= 4) {
        input.value = `${parts[2]}.${parts[3]}`
        return
      }
    }

    const setClientId = (id) => {
      if (id && id !== 'undefined' && id !== 'null') {
        input.value = id
      } else {
        input.value = crypto.randomUUID()
      }
    }

    const waitForGtag = () => {
      if (typeof window.gtag === 'function') {
        try {
          window.gtag('get', 'G-5BM1C2LY27', 'client_id', (id) => {
            setClientId(id)
          })
        } catch (error) {
          setClientId(null)
        }
      } else {
        setTimeout(() => {
          if (typeof window.gtag !== 'function') {
            setClientId(null)
          } else {
            waitForGtag()
          }
        }, 200)
      }
    }

    waitForGtag()
  }

  setupGaSessionId(input) {
    const setSessionId = (id) => {
      if (id && id !== 'undefined' && id !== 'null') {
        input.value = id
      } else {
        try {
          input.value = crypto.randomUUID()
        } catch (error) {
          input.value = this.generateFallbackId()
        }
      }
    }

    const waitForGtag = () => {
      if (typeof window.gtag === 'function') {
        try {
          window.gtag('get', 'G-5BM1C2LY27', 'session_id', (id) => {
            setSessionId(id)
          })
        } catch (error) {
          setSessionId(null)
        }
      } else {
        setTimeout(() => {
          if (typeof window.gtag !== 'function') {
            setSessionId(null)
          } else {
            waitForGtag()
          }
        }, 200)
      }
    }

    waitForGtag()
  }

  generateFallbackId() {
    return 'fallback-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9)
  }

  validateAndSetValues() {
    this.querySelectorAll('input[data-cookie-key]').forEach((input) => {
      if (!input.value || input.value.trim() === '') {
        const cookieKey = input.dataset.cookieKey

        switch (cookieKey) {
          case '_ga':
            this.setupGaClientId(input)
            break
          case '_ga_5BM1C2LY27':
            this.setupGaSessionId(input)
            break
        }

        if (!input.value || input.value.trim() === '') {
          try {
            input.value = crypto.randomUUID()
          } catch (error) {
            input.value = this.generateFallbackId()
          }
        }
      }
    })
  }
}
customElements.define('cart-attributes', CartAttributes)

class CartSummaryTableRowToggle extends HTMLElement {
  constructor() {
    super()
    this.button = this.querySelector('button')
    this.button.addEventListener('click', (evt) => {
      evt.preventDefault()
      const table = this.closest('table')
      if (table) {
        table.classList.toggle('is-collapsed')
        const isCollapsed = table.classList.contains('is-collapsed')
        this.button.setAttribute('aria-expanded', !isCollapsed)
        this.button.setAttribute('aria-label', isCollapsed ? 'Show Details' : 'Hide Details')
        this.button.innerHTML = isCollapsed ? 'Show Details' : 'Hide Details'
      }
    })
  }
}
customElements.define('cart-summary-table-row-toggle', CartSummaryTableRowToggle)

document.addEventListener('cartaddsuccess', function (evt) {
  const cartDrawer = document.querySelector('cart-drawer')
  const cartDrawerItems = document.querySelector('cart-drawer-items')
  if (cartDrawer === null || cartDrawerItems === null) return

  const openCart = typeof evt?.detail?.openCart !== 'undefined' ? evt?.detail?.openCart : true
  const refreshCart =
    typeof evt?.detail?.refreshCart !== 'undefined' ? evt?.detail?.refreshCart : true

  if (openCart) cartDrawer.open()
  if (refreshCart) refreshCartDrawer(cartDrawer, cartDrawerItems)
})

document.addEventListener('do-refresh-cart', () => {
  const cartDrawer = document.querySelector('cart-drawer')
  const cartDrawerItems = document.querySelector('cart-drawer-items')
  if (cartDrawer === null || cartDrawerItems === null) return

  refreshCartDrawer(cartDrawer, cartDrawerItems)
})

function refreshCartDrawer(cartDrawer, cartDrawerItems) {
  cartDrawer.classList.remove('is-empty')
  cartDrawer.classList.add('is-loading')
  cartDrawerItems.onCartUpdate()

  // Update cart count
  if (document.querySelector('#cart-icon-bubble') !== null) {
    fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const sourceQty = html.querySelector('.shopify-section')
        document.querySelector('#cart-icon-bubble').innerHTML = sourceQty.innerHTML
      })
      .catch((e) => {
        console.error(e)
      })
  }
}

document.addEventListener('rivo-accounts:shopify:login', () => {
  const cartDrawer = document.querySelector('cart-drawer')
  const cartDrawerItems = document.querySelector('cart-drawer-items')
  if (cartDrawer === null || cartDrawerItems === null) return

  cartDrawer.classList.add('is-loading')
  cartDrawerItems.onCartUpdate()
})
